module.exports = __webpack_public_path__ + "img/1.fdbdcd22.png";